import React from 'react';
import "./Rent2Rent.css";
import { FaHome, FaShieldAlt, FaUsers, FaTools } from 'react-icons/fa';

const Rent2Rent = () => {
  const features = [
    {
      icon: <FaHome size={40} className="text-brown" />,
      title: "Optimización de alquileres",
      description: "Maximizamos el potencial de tu propiedad con estrategias de alquiler eficientes."
    },
    {
      icon: <FaShieldAlt size={40} className="text-brown" />,
      title: "Cero riesgos para ti",
      description: "Nosotros asumimos todos los riesgos: impagos, daños, vacantes."
    },
    {
      icon: <FaUsers size={40} className="text-brown" />,
      title: "Selección de inquilinos",
      description: "Elegimos inquilinos confiables y responsables para tu tranquilidad."
    },
    {
      icon: <FaTools size={40} className="text-brown" />,
      title: "Gestión completa",
      description: "Mantenimiento, limpieza, suministros y reparaciones incluidas."
    }
  ];

  return (
    <div className='rent2rent section-p' id="rent2rent">
        <div className='container'>
            <div className='rent2rent-content'>
                <div className='section-title'>
                    <h3 className='text-brown'>¿Qué hacemos? <span className='text-dark'>(Gestión Integral)</span></h3>
                    <p className='text'>Nos encargamos de la gestión completa de tu inmueble, optimizando alquileres y asumiendo todos los riesgos para garantizarte ingresos estables.</p>
                </div>
                <div className='rent2rent-features grid'>
                    {features.map((feature, index) => (
                        <div className='feature-item text-center' key={index}>
                            <div className='feature-icon'>
                                {feature.icon}
                            </div>
                            <h4 className='feature-title'>{feature.title}</h4>
                            <p className='feature-description'>{feature.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
  )
}

export default Rent2Rent